var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AABABA;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.7,26.4h-5.2v-1.9c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1v1.9h-6.6v-1.9c0-0.6-0.5-1.1-1.1-1.1 s-1.1,0.5-1.1,1.1v1.9h-6.6v-1.9c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1v1.9h-5.2c-2.7,0-4.9,2.2-4.9,4.9v25.3 c0,2.7,2.2,4.9,4.9,4.9h30.5c2.7,0,4.9-2.2,4.9-4.9V31.4C62.7,28.7,60.5,26.4,57.7,26.4z M60.4,56.7c0,1.5-1.2,2.6-2.6,2.6H27.3 c-1.5,0-2.6-1.2-2.6-2.6V31.4c0-1.5,1.2-2.6,2.6-2.6h5.2v2.8c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-2.8h6.6v2.8 c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-2.8h6.6v2.8c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-2.8h5.2c1.5,0,2.6,1.2,2.6,2.6V56.7z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 37.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 44.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 51.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 37.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 44.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 51.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 37.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 44.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 51.3,
    className: "st1",
    width: 6.6,
    height: 4.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/Custom.d5e609cd95d4eba6ea53cc4d51acfad4.svg";
export { ForwardRef as ReactComponent };